export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      when: 'beforeChildren',
      staggerChildren: 0.2,
    },
  },
};

export const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export const itemVariantsNoY = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5 } },
};

export const itemFadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.3 } },
};

export const textVariants = {
  hidden: {
    opacity: 0,
    y: 50,
    transition: { duration: 0.6, ease: [0.6, 0, 0.4, 1], delay: 0 },
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.6, 0, 0.4, 1], delay: 0.2 },
  },
};

export const heroHeadingVariants = {
  hidden: {
    opacity: 0,
    y: 50,
    transition: { duration: 0.8, ease: [0.6, 0, 0.4, 1], delay: 0 },
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.6, 0, 0.4, 1], delay: 0 },
  },
};

export const lineTextVariants = {
  hidden: {
    width: 0,
    marginRight: 0,
    transition: { duration: 1.2, ease: [0.6, 0, 0.4, 1], delay: 0 },
  },
  visible: {
    width: 65,
    marginRight: 16,
    transition: {
      width: { duration: 1.2, ease: [0.6, 0, 0.4, 1], delay: 0.8 },
      marginRight: { duration: 1.2, ease: [0.6, 0, 0.4, 1], delay: 0.6 },
    },
  },
};

export const contentVariants = {
  hidden: { opacity: 0, height: 0 },
  visible: { opacity: 1, height: 'auto' },
};

export const viewPort = {
  once: true,
  margin: '-100px',
};
